export default __webpack_public_path__ + "static/working_equine_1-0e30534555946084bab30bb930df3ad4.jpg";